// @flow
import React from 'react'
import styled from 'styled-components'

import {
  SolutionsSection,
  SupportSection,
  GoalSection,
} from './'

export const HomePage = () => {
  return (
    <HomePageStyles>
      <SolutionsSection />
      <SupportSection />
      <GoalSection />
    </HomePageStyles>
  )
}

const HomePageStyles = styled.div`

`



// WEBPACK FOOTER //
// ./src/components/HomePage.js